module.exports = __webpack_public_path__ + "media/images/logo-92ba0a4c63c2630666922b35ddac0aed.png";